<script lang="ts">
import type { DirectiveBinding } from "vue";

const useResizeObserver = (el, callback) => {
  var requestID = 0;
  const resizeObserver = new ResizeObserver((entries) => {
    if (!Array.isArray(entries) || !entries.length) {
      return;
    }       
    if (requestID) {
		  window.cancelAnimationFrame(requestID);
	  }
    requestID = requestAnimationFrame(() => {
      const entry = entries[0];

      requestID = 0;
      callback({
        width: Math.round(entry.contentRect.width),
        height: Math.round(entry.contentRect.height),
      });
    });
  });
  resizeObserver.observe(el);

  return () => {
    resizeObserver.unobserve(el);
  };
};


export default {
  mounted(el: any, binding: DirectiveBinding) {
    if (typeof binding.value === 'function') {
      el._observerHandler = useResizeObserver( el, binding.value );
    }
  },

  beforeUnmount(el: any) {
    if (el._observerHandler){
      el._observerHandler();
      delete el._observerHandler;
    }
  },
};
</script>
